import {
  CreateRegistrationDto,
  GetRegistrationDto,
  MessageResponseDto,
  ProcessRegistrationDto,
  RegistrationApiFp,
  RegistrationControllerGet200Response,
} from "@api/api";
import { apiConfig } from "@factory/query/config";
import { QueryKey } from "@factory/query/query-key.enum";

export type GetResponseRegistrationModel = RegistrationControllerGet200Response;
export type GetRegistrationModel = GetRegistrationDto;
export type MutateResponseRegistrationModel = MessageResponseDto;
export type CreateRegistrationModel = CreateRegistrationDto;
export type ProcessRegistrationModel = ProcessRegistrationDto;

export interface CreateRegistratioModelExtension {
  registration: CreateRegistrationModel;
  file: File;
}

export const apiRegistrationFp = RegistrationApiFp(apiConfig);
export const getRegistrationController =
  apiRegistrationFp.registrationControllerGet;
export const createRegistrationController =
  apiRegistrationFp.registrationControllerCreate;
export const proceedRegistrationController =
  apiRegistrationFp.registrationControllerProceed;

export const QueryKeyRegistration = QueryKey.Registration;
